import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { history, useIntl } from 'umi';
import { Alert, Segment, Button, Table } from 'tea-component';
import '@/pages/intelligence/assets/scss/MarketProfile/TabDetails/Stats.scss';
import { formatNum, formatPercentNum } from '@/pages/intelligence/utils/commonUtils';
import '@/pages/intelligence/pages/MarketProfile/TabDetails/Stats/index.scss';
import TableShowData from '@/pages/intelligence/components/TableComponents/components/TableShowData';
import SortBy from '@/pages/intelligence/components/TableComponents/components/SortBy';
import AppAnnie from '@/pages/intelligence/assets/svg/dataSource/app-annie.svg';
import { DataSourceBubbleContent } from '@/pages/intelligence/components/DataSourceBubbleContent';
import mscience32 from '@/pages/intelligence/assets/svg/marketprofile/mscience32.svg';
import npd from '@/pages/intelligence/assets/svg/dataSource/npd.svg';
import defaltCountryImg from '@/pages/home/assets/img/flag/default.svg';
import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import { dbiBtnLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import {
  TableCheckboxHeader,
  TableCheckboxRender,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
const { scrollable, pageable } = Table.addons;

export default function CompanyTable(props: any) {
  const {
    showTableData,
    changeTableSort,
    sortColunms,
    sortOrder,
    gameType,
    selectedKeys,
    selectedAllKeys,
    changeSelectedKeys,
    changeSelectedKeysColor,
    onPagingChange,
    dataType,
    tableLength,
    pageSize,
    pageIndex,
    onCompanySortChange,
  } = props;
  const { formatMessage } = useIntl();
  const color = [
    '#376AE7',
    '#3ECBFF',
    '#4FCB87',
    '#FFD14E',
    '#ED9142',
    '#E95F6A',
    '#CF61AC',
    '#8164CD',
    '#6585F7',
    '#A0B6FA',
    '#3ba272',
  ];
  const pcColor = [
    '#376AE7',
    '#3ECBFF',
    '#4FCB87',
    '#FFD14E',
    '#ED9142',
    '#E95F6A',
    '#CF61AC',
    '#8164CD',
    '#6585F7',
    '#A0B6FA',
    '#3ba272',
  ];

  const tableColumns = [
    {
      key: 'select',
      width: 37,
      fixed: 'left',
      header: () => {
        return (
          <TableCheckboxHeader
            selectList={selectedKeys}
            tableSelectionAll={selectedAllKeys}
            onChange={(list: any, type: any) => {
              if (type == 'all') return;
              changeSelectedKeysColor({});
              selectedKeys.length = 0;
              changeSelectedKeys([...selectedKeys]);
            }}
          />
        );
      },
      render: (cvm: any) => {
        return (
          <TableCheckboxRender
            selectList={selectedKeys}
            cvm={{ ...(cvm || {}), gameId: cvm?.app_id }}
            onChange={(list: any) => {
              changeSelectedKeys(list);
              const selectedKeysColorTemp = [] as any;

              list.forEach((item: any, index: number) => {
                if (list.length < 6) {
                  let itemColor = '';
                  if (gameType == 'mobile') {
                    itemColor = color[index];
                  } else {
                    itemColor = pcColor[index];
                  }
                  selectedKeysColorTemp[item.app_id] = itemColor;
                }
              });
              changeSelectedKeysColor(selectedKeysColorTemp);
            }}
          />
        );
      },
    },
    {
      key: 'id',
      header: (
        <div className="dbi-firstRow-flex">
          <span className="dbi-text-id">#</span>
          <span>{formatMessage({ id: 'dbi_company_companies' })}</span>
        </div>
      ),
      fixed: 'left',
      render: (cvm: any) => (
        <FirstRow
          id={cvm.rank}
          cvm={{
            // imgType: gameType,
            // 这里是Company的表格，展示company的信息，所以这里图片类型固定是company，不受游戏mobile、pc、console的影响
            imgType: 'company',
            gametitle: cvm.name,
            img: cvm.companyIcon,
            countryIcon: cvm.conutryFlag || defaltCountryImg,
            text: cvm.conutryName,
          }}
          onClick={() => {
            buriedBtnPoint(dbiBtnLogMes.marketProfileStatsClickCompany);
            const sta = {
              app_id: cvm.app_id,
              name: cvm.name,
            };
            history.push({
              pathname: `/intelligence/topCharts/companies/gamesDetails/${cvm.app_id}/Summary/revenue`,
              state: sta,
            });
          }}
          rihgtClickToJumpHref={`/intelligence/topCharts/companies/gamesDetails/${cvm.app_id}/Summary/revenue`}
        />
      ),
    },
    {
      key: 'revenue',
      align: 'right',
      header: (
        <CloumsCenter width={260} align={'right'}>
          <SortBy
            // type="font_sort"
            title={
              gameType === 'mobile'
                ? formatMessage({ id: 'dbi_revenue_$' })
                : formatMessage({ id: 'dbi_metric_digitalRevenue' })
            }
            svgIcon={gameType === 'mobile' ? AppAnnie : mscience32}
            filter={changeTableSort}
            defaultKey={sortColunms[0]}
            defaultValue={sortOrder?.[sortColunms[0]] || 'desc'}
            onChange={onCompanySortChange}
            svgTip={
              <DataSourceBubbleContent
                sourceNameLocalId={
                  gameType === 'mobile'
                    ? formatMessage({ id: 'dbi_revenue_$' })
                    : formatMessage({ id: 'dbi_metric_digitalRevenue' })
                }
                metric={gameType === 'mobile' ? 'appannie' : 'mscience'}
                metricKey={gameType === 'mobile' ? 'revenue' : 'digitalRevenue'}
                entityType={gameType}
              />
            }
            // content={
            //   <div style={{ maxWidth: '418px' }}>
            //     Take the SUM value in selected time interval.
            //   </div>
            // }
            content={
              gameType === 'mobile' ? (
                <>
                  {formatMessage({ id: 'dbi_info_sum_selected' })}
                  <br />
                  {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
                </>
              ) : (
                <>{formatMessage({ id: 'dbi_info_sum_selected' })}</>
              )
            }
            list={[
              {
                key: gameType === 'mobile' ? 'gameRevenueA' : 'gameRevenueD',
                text: formatMessage({ id: 'dbi_revenue_$' }),
                title:
                  gameType === 'mobile'
                    ? formatMessage({ id: 'dbi_revenue_$' })
                    : formatMessage({ id: 'dbi_metric_digitalRevenue' }),
              },
              {
                key: gameType === 'mobile' ? 'gameRevenueAChange' : 'gameRevenueDChange',
                text: `${formatMessage({ id: 'dbi_revenue_$' })}:${formatMessage({
                  id: 'dbi_change',
                })}(%)`,
                title:
                  gameType === 'mobile'
                    ? `${formatMessage({ id: 'dbi_revenue_$' })}%`
                    : `${formatMessage({ id: 'dbi_metric_digitalRevenue' })}%`,
              },
            ]}
          />
        </CloumsCenter>
      ),
      render: (cvm: any) => (
        <CloumsCenter width={260} align={'right'}>
          <TableShowData
            value={
              cvm[gameType === 'mobile' ? 'revenue' : 'revenueDigital'] == 0
                ? '-'
                : formatNum(cvm[gameType === 'mobile' ? 'revenue' : 'revenueDigital'], true)
            }
            type={
              cvm[gameType === 'mobile' ? 'revenueChange' : 'revenueDigitalChange'] > 0
                ? 'up'
                : cvm[gameType === 'mobile' ? 'revenueChange' : 'revenueDigitalChange'] < 0
                ? 'down'
                : ''
            }
            growth={
              cvm[gameType === 'mobile' ? 'revenueChange' : 'revenueDigitalChange'] == 0
                ? '-'
                : formatPercentNum(
                    cvm[gameType === 'mobile' ? 'revenueChange' : 'revenueDigitalChange'],
                  )
            }
          />
        </CloumsCenter>
      ),
    },
    {
      key: 'download',
      align: 'right',
      header: (
        <CloumsCenter width={260} align={'right'}>
          <SortBy
            // type="font_sort"
            title={
              gameType === 'mobile'
                ? formatMessage({ id: 'dbi_downloads' })
                : formatMessage({ id: 'dbi_metric_physical_revenue' })
            }
            svgIcon={gameType === 'mobile' ? AppAnnie : npd}
            filter={changeTableSort}
            defaultKey={sortColunms[0]}
            defaultValue={sortOrder?.[sortColunms[0]] || 'desc'}
            onChange={onCompanySortChange}
            svgTip={
              <DataSourceBubbleContent
                sourceNameLocalId={
                  gameType === 'mobile'
                    ? formatMessage({ id: 'dbi_downloads' })
                    : formatMessage({ id: 'dbi_metric_physical_revenue' })
                }
                metric={gameType === 'mobile' ? 'appannie' : 'npd'}
                metricKey={gameType === 'mobile' ? 'download' : 'physical_revenue'}
                entityType={gameType}
              />
            }
            content={
              gameType === 'mobile' ? (
                <>
                  {formatMessage({ id: 'dbi_info_sum_selected' })}
                  <br />
                  {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
                </>
              ) : (
                <>{formatMessage({ id: 'dbi_info_sum_selected' })}</>
              )
            }
            list={[
              {
                key: gameType === 'mobile' ? 'gameDownloadA' : 'gameRevenueP',
                text:
                  gameType === 'mobile'
                    ? formatMessage({ id: 'dbi_downloads' })
                    : formatMessage({ id: 'dbi_revenue_$' }),
                title:
                  gameType === 'mobile'
                    ? formatMessage({ id: 'dbi_downloads' })
                    : formatMessage({ id: 'dbi_metric_physical_revenue' }),
              },
              {
                key: gameType === 'mobile' ? 'gameDownloadAChange' : 'gameRevenuePChange',
                text:
                  gameType === 'mobile'
                    ? `${formatMessage({ id: 'dbi_downloads' })}:${formatMessage({
                        id: 'dbi_change',
                      })}(%)`
                    : `${formatMessage({ id: 'dbi_revenue_$' })}:${formatMessage({
                        id: 'dbi_change',
                      })}(%)`,
                title:
                  gameType === 'mobile'
                    ? `${formatMessage({ id: 'dbi_downloads' })}(%)`
                    : `${formatMessage({
                        id: 'dbi_metric_physical_revenue',
                      })}(%)`,
              },
            ]}
          />
        </CloumsCenter>
      ),
      render: (cvm: any) => (
        <CloumsCenter width={260} align={'right'}>
          <TableShowData
            value={
              cvm[gameType === 'mobile' ? 'download' : 'revenuePhysical'] == 0
                ? '-'
                : formatNum(cvm[gameType === 'mobile' ? 'download' : 'revenuePhysical'], true)
            }
            type={
              cvm[gameType === 'mobile' ? 'downloadChange' : 'revenuePhysicalChange'] > 0
                ? 'up'
                : cvm[gameType === 'mobile' ? 'downloadChange' : 'revenuePhysicalChange'] < 0
                ? 'down'
                : ''
            }
            growth={
              cvm[gameType === 'mobile' ? 'downloadChange' : 'revenuePhysicalChange'] == 0
                ? '-'
                : formatPercentNum(
                    cvm[gameType === 'mobile' ? 'downloadChange' : 'revenuePhysicalChange'],
                  )
            }
          />
        </CloumsCenter>
      ),
    },
    {
      key: 'settings',
      header: (
        <CloumsCenter width={160} align={'left'} titleStyle={true}>
          {formatMessage({ id: 'dbi_actions' })}
        </CloumsCenter>
      ),
      align: 'right',
      render: (cvm: any) => (
        <CloumsCenter width={160} align={'left'}>
          <Button
            className="btn-details"
            type="link"
            onClick={() => {
              buriedBtnPoint(dbiBtnLogMes.marketProfileInsightsClickCompany);
              const sta = {
                app_id: cvm.app_id,
                name: cvm.name,
              };
              history.push({
                pathname: `/intelligence/topCharts/companies/gamesDetails/${cvm.app_id}/Summary/revenue`,
                state: sta,
              });
            }}
          >
            {formatMessage({ id: 'dbi_details' })}
          </Button>
        </CloumsCenter>
      ),
    },
  ];

  return (
    <Table
      className="tablecard-box dbi-table-selectable dbi-table-sticky"
      bordered="all"
      records={showTableData}
      columns={tableColumns}
      addons={[
        // scrollable({
        //   minWidth: 1800,
        // }),
        pageable({
          recordCount: dataType == 'game' ? tableLength : showTableData?.length || 0,
          isPagingReset: true,
          stateText: `Total items: ${
            dataType == 'game' ? tableLength : showTableData?.length || 0
          }`,
          pageSizeOptions: dataType == 'operation' ? [5, 10, 20] : [10, 20, 50],
          // pageCountChangingResetType: 'last',
          pageSize,
          pageIndex,
          onPagingChange,
        }),
      ]}
    />
  );
}
